import React from 'react';

import FlyoutLeft from './FlyoutLeft';
import SideNavigationBar from './SideNavigationBar';

import { Logout } from '../../icons';

interface SideBarAnimationProps {
    open: boolean;
    type: 'requester' | 'ops' | 'admin' | 'vendor';
    onClick: () => void;
}

const SideBarAnimation = ({ open, type, onClick }: SideBarAnimationProps) => {
    return (
        <FlyoutLeft open={open}>
            <div className="flex flex-col content-center h-full">
                <div className="bg-white h-full dark:bg-gray-700 my-12">
                    <SideNavigationBar type={type} />
                </div>
                <div className="mt-auto">
                    <button onClick={onClick} className="w-full font-thin capitalize text-gray-500 dark:text-gray-200 flex items-center p-4 transition-colors duration-200 justify-start">
                        <span className="text-left">
                            <Logout />
                        </span>
                        <span className="mx-5 text-sm font-normal whitespace-nowrap text-red-600">Logout</span>
                    </button>
                </div>
            </div>
        </FlyoutLeft>
    );
};

export default React.memo(SideBarAnimation);
